// extracted by mini-css-extract-plugin
module.exports = {"pointer":"chat_pointer__1TTRt","layout":"chat_layout__2YPVn","side":"chat_side__2kvyI"};